// The template shipped as "Ecme". This constant reaches the footer on every
// page and is the wordmark rendered by `components/template/Logo.tsx`.
export const APP_NAME = 'TrackHeros'
export const REDIRECT_URL_KEY = 'redirectUrl'
